import styled from "styled-components";

export const ContainerGraphic = styled.div`
    width: 100%;
    height: auto;
    /* max-width: 11rem; */

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`;

export const ContainerGraphicsItem = styled.div`
    width: auto;
    height: auto;

    gap: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
`;

export const GraphicsItem = styled.div`
    width: auto;
    height: auto;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    > p {
        font-weight: 600;
        font-family: "Lato";
        font-size: 0.563rem;
        line-height: 0.844rem;
        letter-spacing: 0.1em;
        text-transform: uppercase;
    }
`;